import { styled } from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const Body = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

export const Main = styled.div`
  display: flex;
  width: 100%;
  grid-column: auto / span 6;
  justify-content: center;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    grid-column: auto / span 12;
  }
`;

export const Sidebar = styled.div`
  display: flex;
  grid-column: auto / span 3;
  width: 200px;
  min-width: 200px;
  margin-left: 48px;
  margin-right: 52px;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-left: 90px;
  }

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const SidebarContent = styled.div`
  bottom: 40px;
  position: sticky;
  top: 150px;
  align-self: flex-start;
`;
